<template>
    <div class="bordered">
        <form @submit.prevent="onSubmit">
            <b-table-simple borderless>
                <colgroup>
                    <col style="width:17%;"/>
                    <col style="width:26%;"/>
                    <col style="width:7%;"/>
                    <col style="width:10%;"/>
                    <col style="width:30%;"/>
                    <col style="width:20%;"/>
                </colgroup>
                <b-thead>
                    <b-tr>
                        <b-th>Artikelnr.</b-th>
                        <b-th>Artikelnaam</b-th>
                        <b-th>Aantal</b-th>
                        <b-th>Stuksprijs</b-th>
                        <b-th>Bezorgmethode</b-th>
                        <b-th>Beoogde leverdatum</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>
                            <b-input v-model="product_identifier"
                                     placeholder="Artikelnr."
                                     pattern="\d+" required
                                     size="sm"
                                     :readonly="validated"
                                     :plaintext="validated"
                            />
                        </b-td>
                        <b-td>
                            <b-input v-model="product_name"
                                     :placeholder="(!validationEnabled) ? 'Artikelnaam' : ''"
                                     required
                                     size="sm"
                                     :readonly="validated || validationEnabled"
                                     :plaintext="validated || validationEnabled"
                            />
                        </b-td>
                        <b-td>
                            <b-input v-model="quantity"
                                     type="number"
                                     size="sm"
                                     min="1" required
                                     :readonly="validated"
                                     :plaintext="validated"
                            />
                        </b-td>
                        <b-td>
                            &euro;&nbsp;
                            <b-input type="number"
                                     v-model="price"
                                     size="sm"
                                     class="d-inline-block"
                                     style="width:75%;"
                                     min="0"
                                     :readonly="true"
                                     :plaintext="true"
                            />
                        </b-td>
                        <b-td>
                            <small>Wordt overgenomen van de huidige order</small>
                        </b-td>
                        <b-td v-if="!validated">
                            <b-input v-model="delivery_date"
                                     type="date" required
                                     size="sm"
                                     :min="tomorrow"
                                     placeholder="YYYY-MM-DD"
                                     :readonly="validated"
                                     :plaintext="validated"
                            />
                        </b-td>
                        <b-td v-else v-text="delivery_date"></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <p class="text-right">
                <product-stock-status :product-identifier="product_identifier" :quantity="quantity" class="d-inline-block mr-4" :key="`${product_identifier}_${quantity}`"/>

                <b-button :variant="!validationEnabled || validated ? 'success' : 'primary'" type="submit" :disabled="!isSubmittable || isSubmitting">
                    <span v-if="isSubmitting"><font-awesome-icon icon="spinner" spin/></span>
                    <span v-else>{{ !validationEnabled || validated ? 'Toevoegen' : 'Valideer aanvraag'}}</span>
                </b-button>
            </p>
        </form>
    </div>
</template>

<script>
import moment from "moment"
import ProductStockStatus from "@/components/ProductStockStatus.vue";

export default {
    components: {ProductStockStatus},
    props: {
        salesOrder: {required: true},
    },

    data() {
        return {
            isSubmitting: false,
            validationError: false,
            validated: false,
            product_identifier: '',
            product_name: '',
            price: '0.00',
            quantity: 1,
            delivery_date: '',
        }
    },

    created() {
        // Set the initial delivery-date on tomorrow
        this.delivery_date = this.tomorrow
    },

    computed: {
        isSubmittable() {
            return this.product_identifier && this.quantity > 0 && this.delivery_date
                && (
                    (!this.validationEnabled && this.product_name)
                    || (this.validationEnabled)
                )
        },
        validationEnabled() {
            return !!this.$store.state.config['add-sales-order-line']['enable-product-validation-via-pim']
        },
        customPriceEnabled() {
            return !!this.$store.state.config['add-sales-order-line']['enable-product-custom-price']
        },
    },

    methods: {
        onSubmit() {
            this.isSubmitting = true
            let apiCall = !this.validationEnabled || this.validated ? this.send() : this.validate()
            apiCall.then(() => this.isSubmitting = false)
        },

        validate() {
            return this.$http.post(`/api/rest/sales-orders/sales-order-lines/pre-check`, {
                'product_identifier': this.product_identifier,
                'quantity': this.quantity,
                'promised_delivery_date': this.delivery_date,
            })
                .then(response => {
                    this.product_name = response.data.product_name
                    this.validated = true
                })
                .catch(e => {
                    // Check error in 500-range (server error)
                    if (e.response.status % 500 < 100) {
                        this.$alert("Er is iets misgegaan bij het valideren. De orderregel kan wel worden toegevoegd.", "warning")
                        this.validated = true
                    }
                    else if (e.response.status === 422) {
                        let message;
                        switch (e.response.data.errors[0].identifier) {
                            case 'ProductNotFound':
                                message = 'Product niet gevonden'
                                break
                            default:
                                message = e.response.data.errors[0].message
                                break
                        }

                        this.$alert(`Validatie mislukt: ${message}`, 'info')
                    }
                })
        },

        send() {
            return this.$http.post(`/api/rest/sales-orders/${this.salesOrder.identifier}/sales-order-lines`, {
                "product_identifier": this.product_identifier,
                "product_name": this.product_name,
                "quantity": this.quantity,
                "promised_delivery_date": this.delivery_date,
            })
                .then(response => {
                    this.$alert('De orderregel is toegevoegd')
                    this.$emit('success')
                })
                .catch(e => {
                    this.$alert('Er is iets misgegaan bij het toevoegen van de orderregel', 'danger', true)
                })
                .then(() => {})
        },
    }
}
</script>

<style scoped>
.button-valid {
    background-color: #8ad970;
    background-image: linear-gradient(#daeed3, #8ad970);
}

.bordered {
    border: 1px solid #eee;
    padding: .5em;
    margin-bottom: .5em;
}

.text-right {
    text-align: right;
}
</style>
